import { LoginOutlined } from '@ant-design/icons';
import React from 'react';
import styled, { css } from 'styled-components';

import UploadVersionButton from '../Drawers/VersionsDrawer/UploadVersionButton';

const PlaceholderContainer = styled.div`
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
  flex-flow: column;
  line-height: 40px;
`;

const largeIconStyle = css`
  font-size: 135px;
  margin-bottom: -20px;
  color: #dddee0;
`;

const DragTargetIcon = styled(LoginOutlined)`
  transform: rotate(90deg);
  ${largeIconStyle}
`;

interface EmptyPlaceholderProps {
  onFileSelected?: (file: File) => void;
}

function EmptyPlaceholder({ onFileSelected }: EmptyPlaceholderProps) {
  return (
    <PlaceholderContainer>
      <DragTargetIcon />
      <br />
      Drag your lottie animation file here.
      <br />
      <UploadVersionButton onSelected={onFileSelected} />
    </PlaceholderContainer>
  );
}

export default EmptyPlaceholder;
